/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewEncapsulation, Input, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, OnDestroy, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormArray, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import * as moment from 'moment';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import { CustomFieldService } from './custom-field.service';
import { CustomFieldConfig, CustomFieldPayload } from './custom-field-form.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { LineItemPickerComponent } from '../line-item-picker/line-item-picker.component';
import { LineItemPickerColumns, LineItemPickerOptions, LineItemPickerColumnType } from '../line-item-picker/line-item-picker.interface';
import { LineItemPickerService } from '../line-item-picker/line-item-picker.service';
import { Subscription } from 'rxjs';
import { LineItemService } from 'app/core/services/lineitem/lineitem.service';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
dayjs.extend(utc);


@Component({
  selector: 'app-custom-field-form',
  templateUrl: './custom-field-form.component.html',
  styleUrls: ['./custom-field-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomFieldFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() config: CustomFieldConfig;
  @Input() formGroup: UntypedFormGroup;
  @Input() fieldValue: CustomFieldPayload;
  @Input() category: string;
  @Input() options: any = {
    displayInColumn: 6,
    extraClass:'',
  };

  @Input() moduleUid: string;
  @Output() customFieldsLoaded: EventEmitter<any> = new EventEmitter();

  dateFormat: string = 'DD/MM/YYYY';
  dateTimeFormat: string = 'DD/MM/YYYY HH:mm A';
  timeFormat: string;
  timePickerModel: any = {};
  formBuilderMaster: any = {};
  customFields: any[] = [];
  currentValue: any;
  user: any;
  orderedMasterArray: any[] = [];
  dateArray: any = {};
  showMeridian: boolean = true;
  numberRegExValidator: any = /^[0-9]\d*(\.\d+)?$/;
  numberValidator: ValidatorFn = Validators.pattern(this.numberRegExValidator);
  regexValidator: ValidatorFn = Validators.pattern('');
  maxValidator: ValidatorFn = Validators.max(Infinity);
  minValidator: ValidatorFn = Validators.min(-Infinity);

  masterCustomFields: any = {};
  showGroup: any = {};
  lookupPayloadRef = {};
  selectedLineItem = {};
  currentGroupName: string;
  currentFieldName: string;
  deletedFields: any[] = [];
  isRequired: any = {};
  acceptedFileFormat: string = '';

  private formGroupSubscription: Subscription;
  private formBuiderSubscription: Subscription;
  constructor(
    private _dataCollectorService: DataCollectorService,
    public utilityService: UtilityService,
    private _customFieldService: CustomFieldService,
    private _timeFormatPipe: TimeFormatPipe,
    private _fb: UntypedFormBuilder,
    private _localStorageService: LocalStorageService,
    private _zuperDialogService: ZuperDialogService,
    private _lineItemPickerService: LineItemPickerService,
    private _changeDetectorRef: ChangeDetectorRef,
    private lineItemService: LineItemService,
    private eleRef: ElementRef,
    private translateService: TranslateService,
  ) { }

  /**
   * Returns list of group names to show in header
   *
   */
  getCustomFieldHeader(): Array<any> {
    return this.orderedMasterArray;
  }

  changeCustomFieldOrder(): void {
    const masterArray = [];
    for(const key in this.masterCustomFields){
      if(key === 'DEFAULT'){
        masterArray.push([key, 0]);
      }else{
        masterArray.push([key, this.masterCustomFields[key][0]?.['group']?.['order_no']]);
      }
    }

    this.orderedMasterArray = masterArray
                                .sort((a, b)=> a[1] - b[1])
                                .map((ele: any) => ele[0]);
  }

  /**
   * To Determine the type of custom field
   *
   * @param field - Custom field
   * @returns The type of custom field
   */

  getFileType(field: any): string{
    if(field?.field_type === 'MULTI_LINE'){
      return 'text';
    }else if(field?.field_type === 'SINGLE_LINE') {
      return 'text';
    }else if(field?.field_type === 'FILE') {
      return 'file';
    }else if(field?.field_type === 'DATETIME') {
      return 'datetime-local';
    }else if(field?.field_type === 'TIME') {
      return 'time';
    }
  }

  /**
   *
   * @param controlName - Form control name of the time input
   * @param event - Event passed on change of value
   */
  setTimeFormControl(controlName: string, event): void {
    if(!this.utilityService.isEmptyOrUndefined(this.timePickerModel[controlName]) && (this.formGroup.controls[controlName].value || this.formGroup.controls[controlName].value === null )){
      this.formGroup.controls[controlName].setValue(this._timeFormatPipe.transform(this.timePickerModel[controlName]));
    }else{
      this.formGroup.controls[controlName].setValue(null);
    }
  }

  /**
   * Sets the date and assigns it to the input
   *
   * @param picker - reference of the date picker
   * @param name - fromControlName of the datepicker
   */

  setDate(picker,name): void {
    const date = this.formGroup?.controls[name];
    const parsedDate = date?.value ? moment(date?.value).set('second',0) : moment(new Date()).set('second',0);
    picker.select(parsedDate);
  }

  /**
   * Uploads file to server and sets the attachment_path to formControl
   *
   * @param event  - Event passed to determine the file
   * @param formControlName - formControlName of the input
   */
  uploadFile(event: any, formControlName: string): void {
    if(event?.target?.files?.length > 0){
      const file = event.target.files[0];
      const params = {
        'module': this.config?.module,
        'moduleUid': this.moduleUid,
        'attachmentType': 'ATTACHMENT'
      };
      this.utilityService.uploadFile(file, params)
        .subscribe(((res: any) => {
          this.formGroup.controls[formControlName].setValue(res?.data?.attachment_path);
          this._changeDetectorRef.markForCheck();
        }));
    }else{
    }
  }

  /**
   *
   * @param formControlName - FormControlName of the input
   * @param field - Custom field input
   * @param group - Group Name of the custom field
   * @returns if the field in dependent or independent
   */
  checkDependent(formControlName: string, field: any, group: string): boolean {
    let showField = false;
    if(field?.dependent_options?.length > 0){
      field?.dependent_options?.forEach((option: string) => {
        if(this.formGroup.controls[group+'_'+field?.dependent_on]?.value?.[option.trim()]){
          showField = true;
        }else if(this.formGroup.controls[group+'_'+field?.dependent_on]?.value === option.trim()){
          showField = true;
        }
      });
    }else{
      showField = true;
    }
    if(!showField && (field?.hide_field === false)){
      if(field?.is_required ){
        const errorInFormControl = this.formGroup.get(formControlName)?.errors;
        if(this.formGroup.get(formControlName)?.hasValidator(Validators.required)) {
          this.formGroup.get(formControlName)?.removeValidators(Validators.required);
        }
        if(field?.field_type === 'FILE' && errorInFormControl?.error?.['CUSTOM']){
          this.formGroup.get(formControlName)?.clearValidators();
        }
        if(this.formBuilderMaster[formControlName]?.get('checkboxes').hasValidator(this.checkboxIsRequired())){
          this.formBuilderMaster[formControlName]?.get('checkboxes').removeValidators(this.checkboxIsRequired());
        }
        if(this.formGroup.get(formControlName)?.hasValidator(this.checkboxFormRequired())){
          this.formGroup.get(formControlName)?.removeValidators(this.checkboxFormRequired());
        }
        if(this.formGroup.get(formControlName)?.touched){
          this.formGroup.get(formControlName)?.markAsUntouched();
        }
      }

      if(field?.field_validation === 'number'){
        if(this.formGroup.get(formControlName)?.hasValidator(this.numberValidator)) {
          this.formGroup.get(formControlName)?.removeValidators(Validators.pattern(this.numberRegExValidator));
          this.formGroup.get(formControlName)?.removeValidators(this.numberValidator);
        }
      }
      if(field?.field_validation === 'regex'){
        if(this.formGroup.get(formControlName)?.hasValidator(this.regexValidator)) {
          this.formGroup.get(formControlName)?.removeValidators(Validators.pattern(field?.original_template?.regex_value));
          this.formGroup.get(formControlName)?.removeValidators(this.regexValidator);
        }
      }
      if(field?.original_template?.max_value){
        if(this.formGroup.get(formControlName)?.hasValidator(this.maxValidator)) {
          this.formGroup.get(formControlName)?.removeValidators(this.maxValidator);
          this.formGroup.get(formControlName)?.removeValidators(Validators.max(field?.original_template?.max_value));
        }
      }
      if(field?.original_template?.min_value){
        if(this.formGroup.get(formControlName)?.hasValidator(this.minValidator)) {
          this.formGroup.get(formControlName)?.removeValidators(this.minValidator);
          this.formGroup.get(formControlName)?.removeValidators(Validators.min(field?.original_template?.min_value));
        }
      }
      this.formGroup.get(formControlName)?.updateValueAndValidity();
    }else{
      if(field?.hide_field === false){
        if(field?.is_required){
              if(this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(Validators.required) && field?.field_type !== 'FILE' && field?.field_type !== 'MULTI_ITEM') {
                this.formGroup.get(formControlName)?.addValidators(Validators.required);
                this.isRequired[group] = true;
                }
                if(field?.field_type === 'FILE' && this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.fileIsRequired())){
                this.formGroup.get(formControlName)?.setValidators(this.fileIsRequired());
                this.isRequired[group] = true;
                }
                if(this.formBuilderMaster[formControlName]?.get('checkboxes') && !this.formBuilderMaster[formControlName]?.get('checkboxes').hasValidator(this.checkboxIsRequired())){
                this.formBuilderMaster[formControlName]?.get('checkboxes').addValidators(this.checkboxIsRequired());
                this.formBuilderMaster[formControlName]?.updateValueAndValidity();
                }
                if(field?.field_type === 'MULTI_ITEM' && this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.checkboxFormRequired())){
                this.formGroup.get(formControlName)?.setValidators(this.checkboxFormRequired());
                this.isRequired[group] = true;
                }
            }
            if(field?.field_validation === 'number'){
                if(this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.numberValidator)) {
                this.formGroup.get(formControlName)?.addValidators(this.numberValidator);
                }
            }
            if(field?.field_validation === 'regex'){
                if(this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.regexValidator)) {
                this.formGroup.get(formControlName)?.addValidators(Validators.pattern(field?.original_template?.regex_value));
                this.formGroup.get(formControlName)?.addValidators(this.regexValidator);
                }
            }
            if(field?.original_template?.max_value){
                if(this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.maxValidator)) {
                this.formGroup.get(formControlName)?.addValidators(Validators.max(field?.original_template?.max_value));
                this.formGroup.get(formControlName)?.addValidators(this.maxValidator);
                }
            }
            if(field?.original_template?.min_value){
                if(this.formGroup.get(formControlName) && !this.formGroup.get(formControlName)?.hasValidator(this.minValidator)) {
                this.formGroup.get(formControlName)?.addValidators(Validators.min(field?.original_template?.min_value));
                this.formGroup.get(formControlName)?.addValidators(this.minValidator);
                }
            }
            this.formGroup.get(formControlName)?.updateValueAndValidity();
        }
    }
    return showField;
  }

  get applyClass(): string{
    return `grid grid-cols-${this.options.displayInColumn} ${this.options.extraClass}`;
}

  handleBlur(event: Event): void {
    const target = event.target as HTMLInputElement;
    target.blur();
  }

  //Custom Validators
  checkboxIsRequired(): ValidatorFn {
    return (group: UntypedFormGroup): { [key: string]: any } | null =>
    {
      let oneChecked = false;
      for(const key in group?.controls){
        if(group.controls[key]['value']){
          oneChecked = true;
        }
      }
      return oneChecked ? null : {error: {
        'CUSTOM': 'required'
      }};
    };
  }

  checkboxFormRequired(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
    {
      let oneChecked = false;
      for(const key in control?.value){
        if(control?.value[key]){
          oneChecked = true;
        }
      }
      return oneChecked ? null : {error: {
        'CUSTOM': 'required'
      }};
    };
  }

  fileIsRequired(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
    {
      let checked = false;
      if(control.value){
        checked = true;
      }
      return checked ? null : {error: {
        'CUSTOM': 'required'
      }};
    };
  }

  //Custom Errors
  hasCheckboxError(name: string): boolean {
    if(this.formBuilderMaster[name]?.get('checkboxes')?.invalid && this.formBuilderMaster[name]?.get('checkboxes')?.dirty){
      return true;
    }
    return false;
  }

  hasFileError(name: string): string{
    if(this.formGroup.controls[name]?.invalid && this.formGroup.controls[name]?.touched){
        return 'text.field_is_required';
    }
    return '';
  }

  checkboxChanged(formControlName: string): void{
    if(this.formBuilderMaster[formControlName]?.get('checkboxes').valid){

      this.formGroup.controls[formControlName]?.setValue(this.formBuilderMaster[formControlName].get('checkboxes').value);
    }else{
      this.formGroup.controls[formControlName]?.setValue('');
    }
    this.formGroup.controls[formControlName]?.updateValueAndValidity();
    this._changeDetectorRef.detectChanges();
  }

  /**
   * Function to check if custom field is visible to Field Executive
   *
   * @param field - Custom field
   * @returns if field is visible to Field Executive
   */
  hasFEAccess(field: any): boolean {
    if(field?.hide_to_fe) {
      if(this.user?.role?.role_key === 'FIELD_EXECUTIVE'){
        return false;
      }else{
        return true;
      }
    }else{
      return true;
    }
  }

  /**
   * Opens Lineitem picker component
   *
   * @param groupName - Group name of the custom field input
   * @param fieldName - formControlName of the custom field input
   */

  openLineItemPicker(groupName: string, fieldName: string): void {
    this.currentGroupName = groupName;
    this.currentFieldName = fieldName;
    if(this.selectedLineItem?.[groupName+'_'+fieldName]?.length > 0){
      this._lineItemPickerService.selectedLineItems.next(this.selectedLineItem?.[groupName+'_'+fieldName]);
    }else{
      this._lineItemPickerService.selectedLineItems.next([]);
    }
    let remoteData = null;
    remoteData = {
      dataUrl: this.lineItemService.lineItemAPIUrls.productUrl,
      params: {
        'filter.product_type': 'PRODUCT,PARTS,SERVICE,BUNDLE',
      }
    };

    const lineItemDialog = this._zuperDialogService.openCustom(LineItemPickerComponent,{
      extraClass: 'line-item-picker-container',
      data: {
          options: {
            multipleLineItems: false,
            pickerType: 'modal',
            columns: this.getLineItemsProductColumns(),
            addFromProductGroup: false,
            remoteData: remoteData,
            filters: {
              search: {
                enabled: true
              },
              category: {
                enabled: true
              }
            },
            header: {
              isEnabled: true,
              headerDisplayKey: 'lineitem.picker.header.choose_text',
              headerDisplayName: 'Choose Line Item'
            },
            footer: {
              isEnabled: true,
              buttonDisplayKey: 'lineitem.picker.add.product_text',
              buttonDisplayName: 'Add Product'
            }
          } as LineItemPickerOptions
        }
    });
    const onAddItemClicked: any = this._lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
      lineItemDialog.close(response);
    });
    lineItemDialog.afterClosed().subscribe(
      (lineItems: any) => {
        onAddItemClicked.unsubscribe();
        if(lineItems?.length > 0){
          this.formGroup.controls[this.currentGroupName+'_'+this.currentFieldName].setValue(lineItems[0]['name']);
          const payloadArray: any = this.config?.isQuickCreate === true ? this._customFieldService?.quickCreateArray?.[this.config.module] : this._customFieldService?.payloadArray;
          for(let i = 0; i < payloadArray?.length; i++){
            if((payloadArray[i]?.group_name && payloadArray[i]?.group_name === this.currentGroupName) && payloadArray[i]?.label === this.currentFieldName && payloadArray[i]?.type === 'LOOKUP'){
              payloadArray[i]['ref_uid'] = lineItems[0]['product_uid'];
              this.lookupPayloadRef[this.currentGroupName+'_'+this.currentFieldName] = lineItems[0]['product_uid'];
            }else if((!payloadArray[i]?.group_name && this.currentGroupName === 'DEFAULT') && payloadArray[i]?.label === this.currentFieldName && payloadArray[i]?.type === 'LOOKUP' ){
              payloadArray[i]['ref_uid'] = lineItems[0]['product_uid'];
              this.lookupPayloadRef['DEFAULT_'+this.currentFieldName] = lineItems[0]['product_uid'];
            }
          }
          this.selectedLineItem[this.currentGroupName+'_'+this.currentFieldName] = [...lineItems];
          if(this.config?.isQuickCreate === true){
            this._customFieldService.quickCreateArray[this.config.module] = [...payloadArray];
          }else{
          this._customFieldService.payloadArray = [...payloadArray];
          }
        }
        this.currentGroupName = '';
        this.currentFieldName = '';
        this._changeDetectorRef.markForCheck();
      }
    );
  }

  /**
   *
   * @param module - module name of lookup
   * @returns the description to be shown in the template
   */
  getLookupModule(module: string): string {
    if(module === 'PRODUCT'){
      return 'Part or Service';
    }
  }

  /**
   *
   * @param control - FormControl of the input
   * @param name - FormControlName of the input
   */

  removeLookUp(control: UntypedFormControl, name: string): void {
    control.setValue('');
    this.lookupPayloadRef[name] = '';
    this.selectedLineItem[name] = [];
    this._lineItemPickerService.selectedLineItems.next([]);
    if(this.config?.isQuickCreate === true){
      this._customFieldService?.quickCreateArray[this.config.module]?.forEach((payload)=>{
        const groupName = payload?.group_name ? payload?.group_name : 'DEFAULT';
        if(payload?.ref_uid && (groupName+'_'+payload?.label === name)){
          payload.ref_uid = '';
        }
      });
    }else{
      this._customFieldService?.payloadArray.forEach((payload)=>{
        const groupName = payload?.group_name ? payload?.group_name : 'DEFAULT';
        if(payload?.ref_uid && (groupName+'_'+payload?.label === name)){
          payload.ref_uid = '';
        }
      });
    }
  }

  /**
   *
   * @returns The config of line items picker
   */

  getLineItemsProductColumns(): LineItemPickerColumns[] {
    return [{
      type: LineItemPickerColumnType.LINE_ITEM,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.CATEGORY,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.TYPE,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.BRAND,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.SPECIFICATION,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.PRICE,
      isEditable: false
    }];
  }

  /**
   *
   * @param field - Custom field
   * @returns if the custom field is associated to selected category
   */

  checkCategory(field: any): boolean {
    if(this.config?.hasCategory){
      if(field?.group?.group_name){
        if(field?.group?.associated_to?.length > 0){
          const categoryFound = field?.group?.associated_to.find(ele => ele === this.category);
          if(categoryFound){
            this.showGroup[field?.group?.group_name] = true;
            return true;
          }else{
            this.showGroup[field?.group?.group_name] = false;
            return false;
          }
        }else if(field?.group?.category?.category_uid){
          this.showGroup[field?.group?.group_name] = field?.group?.category?.category_uid === this.category;
          return field?.group?.category?.category_uid === this.category;
        }else{
          this.showGroup[field?.group?.group_name] = true;
          return true;
        }
      }else{
        this.showGroup['DEFAULT'] = true;
        return true;
      }
    }else{
      if(field?.group?.group_name){
          this.showGroup[field?.group?.group_name] = true;
          return true;
      }else{
        this.showGroup['DEFAULT'] = true;
        return true;
      }
    }
  }

  onChoiceChange(groupName: string, fieldName: string, checkboxItem?: any): void {
    if(this.customFields?.length){
      this.customFields.forEach((field: any) => {
        if(field?.dependent_options?.length > 0){
          let hasDependentValue = false;
          field?.dependent_options.forEach((option: any) => {
            if(checkboxItem){
              const checkboxes = this.formBuilderMaster[groupName + '_' + fieldName]?.get('checkboxes') as UntypedFormGroup;
              for(const key in checkboxes?.controls){
                if(option === key && checkboxes.controls[key]?.value){
                  hasDependentValue = true;
                }
              }
            } else {
              if((option === this.formGroup.get(groupName+'_'+fieldName).value) && (groupName === field?.group?.group_name) && (field?.dependent_on === fieldName)){
                hasDependentValue = true;
              }
              if((option === this.formGroup.get(groupName+'_'+fieldName).value) && (!field?.group?.group_name) && (field?.dependent_on === fieldName)){
                hasDependentValue = true;
              }
            }
          });
          if(!hasDependentValue && field?.group?.group_name && (groupName === field?.group?.group_name) && (field?.dependent_on === fieldName)){
            if(field?.field_type === 'MULTI_ITEM' && this.formBuilderMaster?.[field?.group?.group_name+'_'+field?.field_name]){
              const checkboxes = this.formBuilderMaster[field?.group?.group_name+'_'+field?.field_name].get('checkboxes') as UntypedFormGroup;
              for(const [key, formControl] of Object.entries(checkboxes.controls)){
                formControl.setValue(false);
              }

              this.formGroup.get(field?.group?.group_name+'_'+field?.field_name).setValue(this.formBuilderMaster[field?.group?.group_name+'_'+field?.field_name].get('checkboxes').value);
            }else{
              this.formGroup.get(field?.group?.group_name+'_'+field?.field_name).setValue('');
            }
          } else if(!hasDependentValue && !(field?.group?.group_name) && (groupName === 'DEFAULT') && (field?.dependent_on === fieldName)){
            if(field?.field_type === 'MULTI_ITEM' && this.formBuilderMaster?.['DEFAULT_'+field?.field_name]){
              const checkboxes = this.formBuilderMaster['DEFAULT_'+field?.field_name].get('checkboxes') as UntypedFormGroup;
              for(const [key, formControl] of Object.entries(checkboxes.controls)){
                formControl.setValue(false);
              }
              this.formGroup.get('DEFAULT_'+field?.field_name).setValue(this.formBuilderMaster['DEFAULT_'+field?.field_name].get('checkboxes').value);
            }else{
              this.formGroup.get('DEFAULT_'+field?.field_name).setValue('');
            }
          }
        }
      });
    }
  }

  /**
   * Create formControl of all custom fields present in master custom fields array and returns a payload object
   *
   * @param field - custom field object
   * @returns payload object to be sent to parent component
   */
  constructCustomField(field: any, state?: any): any {
    const payloadObject = {};
    const value = ((field?.default_option === true) && (field?.field_options?.length > 0)) ? field?.field_options[0] : '';
    const disableField = field?.original_template?.read_only && (state === 'edit');

    if(field?.group?.group_name){
      if(this.checkCategory(field)) {
        const groupName = field?.group?.group_name;
        const fieldName = field?.field_name;

        payloadObject['group_name'] = groupName;
        payloadObject['group_uid'] = field?.group?.group_uid;
        payloadObject['hide_field'] = field?.original_template?.hide_field;
        payloadObject['hide_to_fe'] = field?.original_template?.hide_to_fe;
        payloadObject['id'] = field?.original_template?.id;
        payloadObject['label'] = fieldName;
        payloadObject['read_only'] = field?.original_template?.read_only;
        payloadObject['type'] = field?.field_type;
        payloadObject['dependent_on'] = field?.dependent_on;
        payloadObject['dependent_options'] = field?.dependent_options;

        if(field?.lookup_module){
          payloadObject['module_name'] = field?.lookup_module;
        }
        const fieldControlName = groupName + '_' + fieldName;
        const control = this.formGroup.get(fieldControlName);
        
        if(this.masterCustomFields[groupName] && this.utilityService.isEmptyOrUndefined(control)){
          this.masterCustomFields[groupName].push(field);
          this.formGroup.addControl(groupName + '_' + fieldName, new UntypedFormControl({value: value, disabled: disableField}));
        }else if(!field?.hide_field && this.utilityService.isEmptyOrUndefined(control)){
          this.masterCustomFields[groupName] = [field];
          this.formGroup.addControl(groupName + '_' + fieldName, new UntypedFormControl({value: value, disabled: disableField}));
        }

        if(field?.field_type === 'MULTI_ITEM' && this.utilityService.isEmptyOrUndefined(control)){
          this.formBuilderMaster[groupName + '_' + fieldName] = this._fb.group({
            'checkboxes': this._fb.group({})
          });
          this.formGroup.addControl(groupName + '_' + fieldName, new UntypedFormControl({value: '', disabled: disableField}));
          const checkboxes = this.formBuilderMaster[groupName + '_' + fieldName].get('checkboxes') as UntypedFormGroup;
          field?.field_options.forEach((option: any) => {
            checkboxes.addControl(option, new UntypedFormControl({value: false, disabled: disableField}));
          });
          this.checkboxChanged(groupName + '_' + fieldName);
        }else if(!field?.hide_field){
          this.formGroup.addControl(groupName + '_' + fieldName, new UntypedFormControl({value: value, disabled:disableField}));
        }
      }
      this.formGroup?.updateValueAndValidity();
    }else{

      payloadObject['hide_field'] = field?.original_template?.hide_field;
      payloadObject['hide_to_fe'] = field?.original_template?.hide_to_fe;
      payloadObject['id'] = field?.original_template?.id;
      payloadObject['label'] = field?.field_name;
      payloadObject['read_only'] = field?.original_template?.read_only;
      payloadObject['type'] = field?.field_type;
      payloadObject['dependent_on'] = field?.dependent_on;
      payloadObject['dependent_options'] = field?.dependent_options;

      if(field?.lookup_module){
        payloadObject['module_name'] = field?.lookup_module;
      }

      if(this.masterCustomFields['DEFAULT']){
        this.masterCustomFields['DEFAULT'].push(field);
        this.formGroup.addControl('DEFAULT_' + field?.field_name, new UntypedFormControl({value: value, disabled: disableField}));
      }else if(!field?.hide_field){
        this.masterCustomFields['DEFAULT'] = [field];
        this.formGroup.addControl('DEFAULT_' + field?.field_name, new UntypedFormControl({value: value, disabled: disableField}));
      }

      if(field?.field_type === 'MULTI_ITEM'){
        this.formBuilderMaster['DEFAULT_' + field?.field_name] = this._fb.group({
          'checkboxes': this._fb.group({})
        });
        this.formGroup.addControl('DEFAULT_' + field?.field_name, new UntypedFormControl({value: '', disabled: disableField}));
        const checkboxes = this.formBuilderMaster['DEFAULT_' + field?.field_name].get('checkboxes') as UntypedFormGroup;
        field?.field_options.forEach((option: any) => {
          const trimmedOption = option.trim();
          checkboxes.addControl(trimmedOption, new UntypedFormControl({value: false, disabled: disableField}));
        });
        this.checkboxChanged('DEFAULT_' + field?.field_name);
      }else if(!field?.hide_field){
        this.formGroup.addControl('DEFAULT_' + field?.field_name, new UntypedFormControl({value: value, disabled: disableField}));
      }
    }
    return payloadObject;
  }

  /**
   *
   * @param state New | edit state
   * @param value value of custom fields
   * @param editFlag Flag to maintain the fields not in master
   */
  getCustomFields(state?: string, value?: any, editFlag?: boolean): void {
    const urlParams = this.utilityService.constructParam({
      'original_template': this.config.originalTemplate,
      'module_name': this.config.module
    });
    this._dataCollectorService.getData(this._customFieldService.getCustomFields(),urlParams)
      .subscribe(async (res: any) => {
          const payloadArray = [];
          this.customFields = res?.data;
          if(value){
            this.currentValue = value;
          }
            res.data.forEach((field: any) => {
              const customField = _.cloneDeep(this.constructCustomField(field, state))
              if(!this.utilityService.isEmptyOrUndefined(customField)){
                payloadArray.push(customField);
              }
            });
            this.getCustomFieldHeader();
            if(state === 'edit' || state === 'clone'){
              let addDeletedFields = true;
              if(editFlag){
                addDeletedFields = true;
                this.config.page = 'new';
              }
              if(this.config?.isConverted){
                this._changeDetectorRef.detectChanges();
                setTimeout(async ()=>{
                  await this.setValueChange(value);
                }, 500);
              }else{
                await this.setCustomFields(value, addDeletedFields);

                //To add ref_uid of lookup to payload object after setCustomField() function execution
                 for(let i = 0; i < payloadArray.length; i++){
                   if(payloadArray[i]?.['group_name']){
                     if(this.lookupPayloadRef[payloadArray[i]?.['group_name']+'_'+payloadArray[i]?.['label']]){
                       payloadArray[i]['ref_uid'] = this.lookupPayloadRef[payloadArray[i]?.['group_name']+'_'+payloadArray[i]?.['label']];
                     }
                   }else{
                     if(this.lookupPayloadRef['DEFAULT_'+payloadArray[i]?.['label']]){
                       payloadArray[i]['ref_uid'] = this.lookupPayloadRef['DEFAULT_'+payloadArray[i]?.['label']];
                     }
                   }
                 }
               }
            }
            if(this.config?.isQuickCreate === true){
              this._customFieldService.quickCreateArray[this.config.module] = [...payloadArray,...this.deletedFields];
            }else{
              this._customFieldService.payloadArray = [...payloadArray,...this.deletedFields];
            }
            this.changeCustomFieldOrder();
            this.customFieldsLoaded.emit(true);
            this.config?.page === 'edit' && this.config.hasOwnProperty('groupName') ? this.scrollToOpenedFieldGroup(this.config?.groupName) : '';
      });
  }

  openFile(url): void{
    window.open(url, '_blank');
  }

  /**
   * Async loop
   *
   * @param data - Array of custom field values to be iterated
   * @param cb - Callback function to be executed asynchronously
   */
  loop = async (data: any, cb: any): Promise<any> => {
    for (let index: number = 0; index < data.length; index++) {
        await cb(data[index]);
    }
  };

  /**
   * Custom field value is prefilled and returns a promise to execute the function in async way
   *
   * @param values custom field values to be prefilled
   */
  async setCustomFields(values: any, editFlag?: boolean): Promise<void> {
    if(editFlag){
      this.deletedFields = [];
    }
    if(values?.length > 0){
      await this.loop(values, async (field: CustomFieldPayload) => {
        if(field?.group_name && this.formGroup.controls[field?.group_name+ '_'+ field?.label]){
          if(this.masterCustomFields[field?.group_name]?.length > 0){
            const currentField = this.masterCustomFields[field?.group_name]?.find((fld: any)=> fld?.field_name === field?.label);
            field['type'] = currentField?.field_type;
          }
          if(field?.ref_uid){
            this.lookupPayloadRef[field?.group_name+ '_'+ field?.label] = field?.ref_uid;
            this.selectedLineItem[field?.group_name+ '_'+ field?.label] = [{
              product_uid: field?.ref_uid,
              name: field?.value
            }];
          }
          if(field?.type === 'MULTI_ITEM' ){
            const checkboxes = this.formBuilderMaster[field?.group_name + '_' + field?.label]?.get('checkboxes') as UntypedFormGroup;
            const answer = field?.value?.split(',').map(item => item.trim());
            for(const key in checkboxes?.controls){
              const present = answer?.includes(key);
              if(present){
                checkboxes.controls[key].patchValue(true);
              }else{
                checkboxes.controls[key].patchValue(false);
              }
            }
            this.checkboxChanged(field?.group_name + '_' + field?.label);
          }
          else if(field?.type === 'TIME'){
            setTimeout(()=>{
              if(!this.utilityService.isEmptyOrUndefined(field?.value) && field?.value !== 'Invalid date'){
                const timeValue = moment(field?.value, 'HH:mm:ss');
                if (timeValue.isValid()) {
                  this.timePickerModel[field?.group_name + '_' + field?.label] = timeValue;
                  this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(
                    this._timeFormatPipe.transform(this.timePickerModel[field?.group_name + '_' + field?.label])
                  );
                } else {
                  this.timePickerModel[field?.group_name + '_' + field?.label] = null;
                  this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(null);
                }
              }else if (field?.value === 'Invalid date'){
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue('');
              }else{
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue('');
              }
            }, 500);
          }
          else if(field?.type === 'DATE' && field?.value){
            setTimeout(()=>{
              // this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(field?.value);
              const formattedValue = dayjs(field?.value, 'YYYY-MM-DD').format('YYYY-MM-DD');
              if (dayjs(formattedValue, 'YYYY-MM-DD', true).isValid()) {
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(field?.value);
              } else {
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(null);
              }
            }, 500);
          }
          else if(field?.type === 'DATETIME' && field?.value){
            setTimeout(()=>{
              // if(field?.value){
              //   this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(dayjs.utc(field?.value,'YYYY-MM-DD HH:mm:ss').tz(this.utilityService.timeZone).format('YYYY-MM-DD HH:mm:ss'));
              // }
              const formattedValue = dayjs.utc(field?.value, 'YYYY-MM-DD HH:mm:ss').tz(this.utilityService.timeZone).format('YYYY-MM-DD HH:mm:ss');
              if (dayjs(formattedValue, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(formattedValue);
              } else {
                this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(null);
              }
            }, 500);
          }
          else if(field?.type === 'FILE'){
            setTimeout(()=>{
              const fileName = 'File';
              const blob = new Blob(['']);
              const file = new File([blob], fileName);
              const container = new DataTransfer();
              container.items.add(file);
              const inputRef = document.getElementById(`${field?.group_name + '_' + field?.label}`) as HTMLInputElement;
              if(inputRef){
                inputRef.files = container.files;
                if(field?.value){
                  this.formGroup.controls[field?.group_name + '_' + field?.label]?.clearValidators();
                  this.formGroup.controls[field?.group_name + '_' + field?.label]?.updateValueAndValidity({onlySelf: true});
                }
              }
              try{
                if(field?.value){
                  this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue(field?.value);
                }else{
                  this.formGroup.controls[field?.group_name + '_' + field?.label].patchValue('');
                }
              }catch(err){

              }
            },500);
          }
          else {
            setTimeout(()=>{
              if(field?.value){
                this.formGroup.controls[field?.group_name + '_' + field?.label]?.patchValue(field?.value);
              }
            },500);
          }
        }else if(this.formGroup.controls['DEFAULT_' + field?.label] && !field?.group_name){
          if(this.masterCustomFields['DEFAULT']?.length > 0){
            const currentField = this.masterCustomFields['DEFAULT']?.find((fld: any)=> fld?.field_name === field?.label);
            field['type'] = currentField?.field_type;
          }
          if(field?.ref_uid){
            this.lookupPayloadRef['DEFAULT_'+ field?.label] = field?.ref_uid;
            this.selectedLineItem['DEFAULT_'+ field?.label] = [{
              product_uid: field?.ref_uid,
              name: field?.value
            }];
          }
          if(field?.type === 'MULTI_ITEM'){
            const checkboxes = this.formBuilderMaster['DEFAULT_' + field?.label]?.get('checkboxes') as UntypedFormGroup;
            const answer = field?.value?.split(',').map(item => item.trim());
            for(const key in checkboxes?.controls){
              const present = answer?.includes(key);
              if(present){
                checkboxes.controls[key].patchValue(true);
              }else{
                checkboxes.controls[key].patchValue(false);
              }
            }
            if(checkboxes){
              this.checkboxChanged('DEFAULT_' + field?.label);
            }
          }else if(field?.type === 'TIME' && field?.value){
            setTimeout(()=>{
              if(!this.utilityService.isEmptyOrUndefined(field?.value) && field?.value !== 'Invalid date'){
                // this.timePickerModel['DEFAULT_' + field?.label] = moment(field?.value, 'HH:mm:ss');
                // this.formGroup.controls['DEFAULT_' + field?.label].patchValue(this._timeFormatPipe.transform(this.timePickerModel['DEFAULT_' + field?.label]));
                const timeValue = moment(field?.value, 'HH:mm:ss');
                if (timeValue.isValid()) {
                  this.timePickerModel['DEFAULT_' + field?.label] = timeValue;
                  this.formGroup.controls['DEFAULT_' + field?.label].patchValue(
                    this._timeFormatPipe.transform(this.timePickerModel['DEFAULT_' + field?.label])
                  );
                } else {
                  this.timePickerModel['DEFAULT_' + field?.label] = null;
                  this.formGroup.controls['DEFAULT_' + field?.label].patchValue(null);
                }
              }else if (field?.value === 'Invalid date'){
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue('');
              }else{
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue('');
              }
            }, 500);
          }
          else if(field?.type === 'DATE' && field?.value){
            setTimeout(()=>{
              // this.formGroup.controls['DEFAULT_' + field?.label].patchValue(field?.value);
              const formattedValue = dayjs(field?.value, 'YYYY-MM-DD').format('YYYY-MM-DD');
              if (dayjs(formattedValue, 'YYYY-MM-DD', true).isValid()) {
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue(field?.value);
              } else {
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue(null);
              }
            }, 500);
          }
          else if(field?.type === 'DATETIME'){
            setTimeout(()=>{
              // if(field?.value){
              //   this.formGroup.controls['DEFAULT_' + field?.label].patchValue(dayjs.utc(field?.value,'YYYY-MM-DD HH:mm:ss').tz(this.utilityService.timeZone).format('YYYY-MM-DD HH:mm:ss'));
              // }
              const formattedValue = dayjs.utc(field?.value, 'YYYY-MM-DD HH:mm:ss').tz(this.utilityService.timeZone).format('YYYY-MM-DD HH:mm:ss');
              if (dayjs(formattedValue, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue(formattedValue);
              } else {
                this.formGroup.controls['DEFAULT_' + field?.label].patchValue(null);
              }
            }, 500);
          }
          else if(field?.type === 'FILE'){
            setTimeout(()=>{
              const fileName = 'File_Added';
              const blob = new Blob(['']);
              const file = new File([blob], fileName);
              const container = new DataTransfer();
              container.items.add(file);
              const inputRef = document.getElementById(`${'DEFAULT_' + field?.label}`) as HTMLInputElement;
              if(inputRef){
                inputRef.files = container.files;
                if(field?.value){
                  this.formGroup.controls['DEFAULT_' + field?.label]?.clearValidators();
                  this.formGroup.controls['DEFAULT_' + field?.label]?.updateValueAndValidity({onlySelf: true});
                }
              }
              try{
                if(field?.value){
                  this.formGroup.controls['DEFAULT_' + field?.label].patchValue(field?.value);
                }else{
                  this.formGroup.controls['DEFAULT_' + field?.label].patchValue('');

                }
              }catch(err){

              }
            },500);
          }
          else {
              if(field?.value){
                this.formGroup.controls['DEFAULT_' + field?.label]?.patchValue(field?.value);
              }
          }
        } else {
          if(editFlag){
            this.deletedFields.push(field);
          };
        }
        await new Promise((resolve) => {
          resolve(true);
        });
      });
    }
  }

  disabledSort(): number {
     return 0;
  }

  ngOnInit(): void {
    this.dateFormat = this.utilityService.dateFormat;
    this.dateTimeFormat = this.utilityService.dateTimeFormat;
    this.timeFormat = this.utilityService.timeFormat;
    this.acceptedFileFormat = this.utilityService.acceptedFileFormat;
    this.user = this._localStorageService.getLocalStorage('user');
    this.showMeridian = this.utilityService.showMeridian;
    if(this.config?.page ===  'new' && !this.config?.hasCategory){
      this.getCustomFields(this.config?.page);
    }
    this.formGroupSubscription = this.formGroup.valueChanges.subscribe(
      (res: any) => {
        this._changeDetectorRef.markForCheck();
      }
    );
    this.formBuiderSubscription = this._customFieldService.formBuilderSubscription.subscribe(
      (res: any) => {
        if(res){
          Object.keys(this.formBuilderMaster).forEach((key: any) => {
            this.formBuilderMaster[key].get('checkboxes').markAsDirty();
          })
        }
      }
    );
  }

  ngOnDestroy(): void {
    if(this.formGroupSubscription.unsubscribe){
      this.formGroupSubscription.unsubscribe();
    }

    if(this.formBuiderSubscription?.unsubscribe){
      this.formBuiderSubscription?.unsubscribe();
    } 
  }

  async setValueChange(value): Promise<void> {
    let addDeletedFields = false;
    if(this.config.page === 'edit' || this.config.page === 'clone'){
      addDeletedFields = true;
      this.config.page = 'new';
    }
    await this.setCustomFields(value, addDeletedFields);
    const payloadArray = this.config?.isQuickCreate === true ? this._customFieldService?.quickCreateArray[this.config.module] : this._customFieldService?.payloadArray;
    //To add ref_uid of lookup to payload object after setCustomField() function execution
    for(let i = 0; i < payloadArray.length; i++){
      if(payloadArray[i]?.['group_name']){
        if(this.lookupPayloadRef[payloadArray[i]?.['group_name']+'_'+payloadArray[i]?.['label']]){
          payloadArray[i]['ref_uid'] = this.lookupPayloadRef[payloadArray[i]?.['group_name']+'_'+payloadArray[i]?.['label']];
        }
      }else{
        if(this.lookupPayloadRef['DEFAULT_'+payloadArray[i]?.['label']]){
          payloadArray[i]['ref_uid'] = this.lookupPayloadRef['DEFAULT_'+payloadArray[i]?.['label']];
        }
      }
    }
    if(this.config?.isQuickCreate === true){
      this._customFieldService.quickCreateArray[this.config.module] = [...payloadArray,...this.deletedFields];
    }else{
      this._customFieldService.payloadArray = [...payloadArray,...this.deletedFields];  
    }
  }

  // Function to remove all form controls from the FormGroup
  removeAllControls(): any {
    const controlNames = Object.keys(this.formGroup.controls);
    controlNames.forEach((controlName: any) => {
      if(!controlName?.includes('DEFAULT')){
        this.formGroup.removeControl(controlName);
      }
    });
  }

  scrollToOpenedFieldGroup(groupName: string = ''): void {
    setTimeout(() => {
      const groupDOMElement: any = this.eleRef?.nativeElement?.querySelector('#field_group_'+ groupName?.replaceAll(/\s+/g, "_"));
    
      if(groupDOMElement)
        groupDOMElement.scrollIntoView({behavior: 'smooth'});
    }, 500);
  }

  checkScrollClassInEdit(group: string = ''): any {
    if(this.config?.page === 'edit' && this.config?.groupName)
      return (group === 'DEFAULT' && this.config?.groupName === 'Other Details') || group === this.config?.groupName;
    else 
      return (!this.config?.expansionDisabled ? group === 'DEFAULT' : this.config?.expansionDisabled) || this.isRequired[group];
  }

  replaceSpacesWithUnderscore(groupName: string): string {
    return groupName?.replaceAll(/\s+/g, '_');
  }

  ngOnChanges(changes: SimpleChanges): void
    {
        if ('fieldValue' in changes)
        {
          this.currentValue = changes?.fieldValue?.currentValue;
          if(((this.config?.page === 'edit') || (this.config?.page === 'clone')) && changes?.fieldValue?.currentValue && !this.config?.hasCategory && this.customFields?.length === 0){
            this.masterCustomFields = {};
            this.getCustomFields(this.config?.page, changes?.fieldValue?.currentValue, true);
          }else if(this.customFields?.length > 0 && changes?.fieldValue?.currentValue) {
            this.setValueChange(changes?.fieldValue?.currentValue);
          }
        }
        if('category' in changes){
          if(changes?.category.previousValue !== changes?.category?.currentValue && (!changes.category?.firstChange || changes?.category?.currentValue || changes?.category?.currentValue === '')){
            if(this.customFields?.length > 0 && this.config?.hasCategory){
              //Construct formControl and payload object based on newly selected category value
              const payloadArray = [];
              this.customFields.forEach((field: any) => {
                if(field?.group?.group_name && this.checkCategory(field)){
                  const customField = _.cloneDeep(this.constructCustomField(field,this.config?.page))
                  if(!this.utilityService.isEmptyOrUndefined(customField)){
                    const payloadObject = customField;
                    if(this.lookupPayloadRef?.[field?.group?.group_name+'_'+field?.field_name]){
                      payloadObject['ref_uid'] = this.lookupPayloadRef[field?.group?.group_name+'_'+field?.field_name];
                    }
                    if(field?.dependent_on && field?.dependent_options?.length > 0){
                    payloadObject['dependent_on'] = field?.dependent_on;
                    payloadObject['dependent_options'] = field?.dependent_options;
                    }
                    payloadObject['group_name'] = field?.group?.group_name;
                    payloadArray.push(payloadObject);
                  }
                  this.checkDependent(field?.group?.group_name+'_'+field?.field_name, field, field?.group?.group_name);
                }else if(this.checkCategory(field)){
                  const payloadObject = {};
                  payloadObject['hide_field'] = field?.original_template?.hide_field;
                  payloadObject['hide_to_fe'] = field?.original_template?.hide_to_fe;
                  payloadObject['id'] = field?.original_template?.id;
                  payloadObject['label'] = field?.field_name;
                  payloadObject['read_only'] = field?.original_template?.read_only;
                  payloadObject['type'] = field?.field_type;
                  payloadObject['dependent_on'] = field?.dependent_on;
                  payloadObject['dependent_options'] = field?.dependent_options;

                  if(field?.lookup_module){
                    payloadObject['module_name'] = field?.lookup_module;
                    if(this.lookupPayloadRef?.['DEFAULT_'+field?.field_name]){
                      payloadObject['ref_uid'] = this.lookupPayloadRef['DEFAULT_'+field?.field_name];
                    }
                  }
                  payloadArray.push(payloadObject);
                }
              });
              const currentPayloadArray = payloadArray;
              const currentFormControls = currentPayloadArray?.map((ele: any) => (ele?.group_name ?? 'DEFAULT') + '_' + ele?.label);
              const existingFormControls = Object.keys(this.formGroup.controls);
              existingFormControls.forEach((controlName: any) => {
                if(!currentFormControls.includes(controlName)){
                  this.formGroup.removeControl(controlName);
                }
              });
              this.formGroup.updateValueAndValidity();
              const groupName = ['DEFAULT',...payloadArray?.map((ele: any) => ele?.group_name)];
              const masterCustomFields = Object.keys(this.masterCustomFields);
              masterCustomFields.forEach((key: any) => {
                if(!groupName.includes(key)){
                  delete this.masterCustomFields[key];
                }
              });
              this.changeCustomFieldOrder();
              if(this.currentValue){
                if(this.config?.isQuickCreate === true){
                  this._customFieldService.quickCreateArray[this.config.module] = [...payloadArray];
                }else{
                this._customFieldService.payloadArray = [...payloadArray];
                }
                this.setValueChange(this.currentValue);
                return;
              }
              if(this.config?.isQuickCreate === true){
                this._customFieldService.quickCreateArray[this.config.module] = [...payloadArray, ...this.deletedFields];
              }else{
                this._customFieldService.payloadArray = [...payloadArray, ...this.deletedFields];
              }
            }else if (this.customFields?.length === 0 && this.config?.hasCategory){
              this.getCustomFields(this.config?.page, this.currentValue);
              return;
            }
          }
        }
    }

}
